import { gql } from '@apollo/client';

export const TRACTION_TYPES = gql`
  query getAvailableTractionTypes($inputTractionType: String!) {
    getAvailableTractionTypes(inputTractionType: $inputTractionType)
  }
`;
